<template>
	<CreationWizardStepWrapper>
		<template #header>
			<NeedChromeToUseAddOnHeader v-bind="$props" v-on="$listeners" />
		</template>
		<div class="width-100 height-100 flex flex-wrap">
			<div class="flex-col-12">
				<h1>You need to use chrome to use add-ons</h1>
				<h3>Switch to Chrome or download Chrome below</h3>
			</div>
			<div class="flex-1 flex-center--end flex-wrap">
				<div class="button-area flex-col-3">
					<PrimaryButton class="width-100" :href="DOWNLOAD_CHROME_LINK" target="_blank">Download Chrome</PrimaryButton>
				</div>
			</div>
		</div>
	</CreationWizardStepWrapper>
</template>

<script>
const DOWNLOAD_CHROME_LINK = 'https://www.google.com/chrome/';
import WizardStepMixin from '../WizardStepMixin';
import NeedChromeToUseAddOnHeader from './NeedChromeToUseAddOnHeader.vue';
import props from './NeedChromeToUseAddOn.props';
export default {
	name: 'NeedChromeToUseAddOn',
	mixins: [WizardStepMixin],
	props,
	components: { NeedChromeToUseAddOnHeader },
	data() {
		return { DOWNLOAD_CHROME_LINK };
	},
};
</script>

<style lang="scss" scoped>
.button-area {
	min-width: 240px;
}
</style>
